import React, { useState, useRef, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import classNames from 'classnames';

import Button from '@nexus/fff-ui-shared/Button';
import SubscriptionChaining from '../SubscriptionChaining/SubscriptionChaining';

import { formatBytes } from 'utils/admin-csv';
import {
  Toast,
  showSuccessToast,
  showErrorToast,
} from 'shared-components/BaseToast/Toast';
import {
  downloadProductsCSV,
  getChainingJobStatus,
  runChainJob,
  uploadProducts,
} from 'services/api/admin-refills';
import styles from './CsvAdmin.module.scss';

const MESSAGES = {
  success: 'Products have been uploaded successfully',
  failure: ' Products have failed to upload. Please try again.',
};

const CsvAdmin = () => {
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const { disableRefillsAdmin: disableRefillsAdminFF } = useFlags();

  const fileInput = useRef(null);

  const handleChangeFile = (event) => {
    setIsFilePicked(true);
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmission = async () => {
    try {
      await uploadProducts(selectedFile);
      showSuccessToast(MESSAGES.success);
    } catch (error) {
      const errorMsg = JSON.parse(error).message;
      console.error(errorMsg);
      showErrorToast(MESSAGES.failure);
    }
    setIsFilePicked(false);
    fileInput.current.value = '';
  };

  const handleDownload = () => {
    window.location.href = downloadProductsCSV();
  };

  return (
    <>
      <div data-testid="csv-admin" className={styles.container}>
        <h2>reFills Management</h2>
        <div className={styles.csvContainer}>
          <h3>Product bulk upload</h3>
          <div className={styles.buttonsGroup}>
            <label
              htmlFor="upload"
              className={classNames(styles.uploadButton, {
                [styles.uploadDisabled]: disableRefillsAdminFF,
              })}
            >
              UPLOAD CSV
              <input
                id="upload"
                className={styles.upload}
                type="file"
                accept=".csv"
                ref={fileInput}
                onChange={handleChangeFile}
                disabled={disableRefillsAdminFF}
              />
            </label>
            <Button
              variation="black-outline"
              onClick={handleDownload}
              width="48px"
            >
              <i className="far fa-arrow-to-bottom" />
            </Button>
          </div>
        </div>
        {isFilePicked && selectedFile && (
          <div className={styles.fileDetailsContainer}>
            <p>File Details</p>
            <div className={styles.fileDetails}>
              <p>
                Filename: <span>{selectedFile.name}</span>
              </p>
              <p>
                Filetype: <span>{selectedFile.type}</span>
              </p>
              <p>
                Size: <span>{formatBytes(selectedFile.size)}</span>
              </p>
              <p>
                Last Modified Date:{' '}
                <span>
                  {selectedFile.lastModifiedDate.toLocaleDateString()}
                </span>
              </p>
            </div>
            <Button
              variation="black-outline"
              onClick={handleSubmission}
              width="98px"
            >
              SUBMIT
            </Button>
          </div>
        )}
        <SubscriptionChaining />
      </div>
      <Toast />
    </>
  );
};

export default CsvAdmin;
